import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { asTitle } from "utils/Utils";

import { ReportRights } from "core/blueprint/trajectory/TrajectoryBlueprintService";
import { ReportInfo } from "trajectory/TrajectoryService";
import ReportOverviewRow from "./ReportOverviewRow";

export type ReportOverviewTableProps = {
	reports: ReportInfo[];
	rights: ReportRights;
	selected: number[];

	onSelect: (id: number, selected: boolean) => void;
};

export default function ReportOverviewTable(
	props: Readonly<ReportOverviewTableProps>
): JSX.Element {
	const { t } = useTranslation();

	return (
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell />
					<TableCell>{asTitle(t("name"))}</TableCell>
					<TableCell>{asTitle(t("type"))}</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{props.reports.map(report => (
					<ReportOverviewRow
						key={report.id}
						report={report}
						rights={props.rights[report.name]}
						selected={props.selected.includes(report.id)}
						onSelect={props.onSelect}
					/>
				))}
			</TableBody>
		</Table>
	);
}
